var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);export default canUseDOM;